import React from 'react';
import classNames from 'classnames';
import { FIELD_WRAP_PROPS } from './Types';
import { PureComponent } from '../../../dispatcher/modules';
import Container from '../container/Container';
import * as _ from 'lodash';

/**
 * This class/component has the role of wrapping each Field component
 * for the purposes of layout, and its structure
 * @author Stevan Stojanovic
 */
class FieldWrap extends PureComponent<FIELD_WRAP_PROPS, {}> {
  private makeLayoutClassName = (array) => {
    let className = 'tp-';
    const sum = array.length && array.reduce((a, b) => a + b, 0) <= 12;

    if (array.length === 1 && sum) {
      className += array[0];
    }

    if (array.length === 2 && sum) {
      className += array[0] + '-' + array[1];
    }

    if (array.length === 3 && sum) {
      className += array[0] + '-' + array[1] + '-' + array[2];
    }

    if (array.length === 4 && sum) {
      className += array[0] + '-' + array[1] + '-' + array[2] + '-' + array[3];
    }

    return sum ? className : '';
  };

  render() {
    const {
      className = '',
      children,
      withValidation,
      withLargeFields,
      layout = []
    } = this.props;

    const cls = classNames(
      `k-form-field-wrap ${className} ${this.makeLayoutClassName(layout)}`,
      {
        'k-form-field-wrap-with-validation': withValidation,
        'k-form-field-wrap-with-large-fields': withLargeFields
      }
    );

    const containerProps = _.omit(this.props, ['multiple', 'withValidation', 'withLargeFields']);
    return (
      <Container {...containerProps} className={cls}>
        {children}
      </Container>
    );
  }
}

export default FieldWrap;
